import {
  Widget,
  getWidgetProps,
  WPSClient,
  RequestContext,
  DVString,
} from '@utils'
import { Banner } from './components/Banner'
import '../../shared/global.module.scss';

export interface PangaeaBannerProps  {
  banner?: DVString
  csrfToken: string
  context: RequestContext
}

const getProps: getWidgetProps<PangaeaBannerProps> = global.__SERVER__
  ? async ({ context, titleID}, api) => {
    const wpsClient = new WPSClient(api)
    const response = await wpsClient.GetPangaeaBanner(titleID ? { context, titleID } : { context })
    return {
      ...response,
      context
    }
  } : undefined

export const PangaeaBanner: Widget<PangaeaBannerProps> = {
  name: 'pangaea-banner',
  getProps,
  Component: Banner,
}
